export const itemUnitOptions = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
  { id: 1, label: "DOZEN", value: "DOZEN" },
  { id: 2, label: "BOX", value: "BOX" },
  { id: 3, label: "GRAMS", value: "GRAMS" },
  { id: 4, label: "KILOGRAMS", value: "KILOGRAMS" },
  { id: 5, label: "METERS", value: "METERS" },
  { id: 6, label: "TABLETS", value: "TABLETS" },
  { id: 7, label: "UNITS", value: "UNITS" },
  { id: 8, label: "PIECES", value: "PIECES" },
  { id: 9, label: "PAIRS", value: "PAIRS" },
];

export const taxPreferenceOptions = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.

  { id: 1, label: "Taxable", value: "Taxable" },
  { id: 2, label: "Non-Taxable", value: "Non-Taxable" },
  { id: 3, label: "Out Of Scope", value: "Out Of Scope" },
  { id: 4, label: "Non-GST Supply", value: "Non-GST Supply" },
];

export const taxRateOptions = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
  { id: 1, label: "Taxable", value: "Taxable" },
];

export const taxOptions = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
  { id: 1, label: "Non Taxable", value: "Non Taxable", helper: "" },
  {
    id: 2,
    label: "Out of Scope",
    value: "Out of Scope",
    helper:
      "Supplies on which you don't charge any GST or include them in the returns.",
  },
  {
    id: 3,
    label: "Non-GST Supply",
    value: "Non-GST Supply",
    helper:
      "Supplies do not come under GST such as petroleum products and liquor.",
  },
  { id: 4, label: "GST0 [0%]", value: "gst0", percentage: "0", helper: "" },
  { id: 5, label: "GST5 [5%]", value: "gst5", percentage: "5", helper: "" },
  { id: 6, label: "GST12 [12%]", value: "gst12", percentage: "12", helper: "" },
  { id: 7, label: "GST18 [18%]", value: "gst18", percentage: "18", helper: "" },
  { id: 8, label: "GST28 [28%]", value: "gst28", percentage: "28", helper: "" },
];

export const accountTypeOptions = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
  { id: 1, label: "Discount", value: "Discount" },
  { id: 2, label: "General Income", value: "General Income" },
];

export const gstType = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
  { id: 1, label: "SGST + CGST", value: "SGST" },
  { id: 2, label: "IGST", value: "IGST" },
];

export const gstExpenseCat = [
  // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
  { id: 1, label: "InternalExpense", value: "InternalExpense" },
  { id: 2, label: "ExternalExpense", value: "ExternalExpense" },
  { id: 3, label: "ResourceExpense", value: "ResourceExpense" },
  { id: 4, label: "PurchaseOrder", value: "PurchaseOrder" },
];

export const allPaymentMode = [
  { id: 1, label: "Cash", value: "Cash" },
  { id: 2, label: "Bank Transfer", value: "Bank Transfer" },
  { id: 3, label: "Bank Remittance", value: "Bank Remittance" },
  { id: 4, label: "Cheque", value: "Cheque" },
  { id: 5, label: "Stripe", value: "Stripe" },
  { id: 6, label: "Credit Card", value: "Credit Card" },
  { id: 7, label: "Debit Card", value: "Debit Card" },
  { id: 8, label: "UPI Payment", value: "UPI Payment" },
  { id: 9, label: "PayPal", value: "PayPal" },
  { id: 10, label: "Mobile Wallet", value: "Mobile Wallet" },
  { id: 11, label: "Direct Debit", value: "Direct Debit" },
  { id: 12, label: "Gift Card", value: "Gift Card" },
  { id: 13, label: "Installment Plan", value: "Installment Plan" },
  { id: 14, label: "Loyalty Points", value: "Loyalty Points" },
];
